"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhanceError = void 0;
class EnhanceError extends Error {
    constructor(e) {
        super(e.message);
        this.code = e.code !== undefined ? String(e.code) : undefined;
        this.message = e.message;
        this.extra = e.extra;
        this.title = e.title;
        this.okText = e.okText;
        this.modalType = e.modalType;
        this.onOkType = e.onOkType;
        this.isShowQrcode = e.isShowQrcode;
    }
}
exports.EnhanceError = EnhanceError;
//# sourceMappingURL=enhance_error.js.map